// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { SavedAccountingPeriodActivityStatus } from '@/accounting/api/types';

/** Reports whether a period has a locked close or a locked initial true-up. */
export function hasLockedActivity(
  period: SavedAccountingPeriodActivityStatus
): boolean {
  return period.periodClose !== null || period.initialTrueUps.length > 0;
}
